/** @jsx jsx */
import { defineMessage, Trans } from '@lingui/macro';
import { useLingui } from '@lingui/react';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';

export default function BrandDistributionInMarketFacet({
  allValues,
  selectedValues,
  onToggle,
  totalCount,
  count,
  ...rest
}) {
  const { i18n } = useLingui();
  const mappedValues = allValues?.map(({ value, count }) => ({
    value,
    count,
    label: i18n._(`distributionInMarket.${value}`),
  }));
  return (
    <DefaultFacet
      title={<Trans>Distribution in Market</Trans>}
      allValues={mappedValues}
      selectedValues={selectedValues}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    />
  );
}

// The messages have to be defined so `lingui extract` can pick them up and put them into `src/locales/`.
const messages = [
  defineMessage({
    id: 'distributionInMarket.seekingDistribution',
    message: 'Seeking Distribution',
  }),
  defineMessage({
    id: 'distributionInMarket.hasDistribution',
    message: 'Has Distribution',
  }),
];

export { messages };
